import {
    useTheme, Box,  TextField, Button,  Dialog, Table, TableCell, TableBody,  TableContainer, TableHead, TableRow,
    DialogActions,
    DialogContent,
   
    
} from "@mui/material";
import { tokens } from "../../../theme/theme";



const ListOfChildRolls = ({ open, onClose, childRolls }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >

            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                <Box
                    gridColumn="span 9"
                    gridRow="span 2"
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        "& .MuiTable-root": {
                            border: "none",
                            size: "small",
                        },
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                            border: "1px solid",
                            borderColor: `${colors.primary[400]} !important`,
                            padding: "2px",  // Further reduced padding
                        },
                        "& .MuiTableHead-root": {
                            borderBottom: "none",
                        },
                        "& .MuiTableBody-root": {
                            overflowY: "auto",
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.blueAccent[200]} !important`,
                            size: "small",
                        },
                        "& .MuiTableFooter-root": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[700],
                            height: "10px",
                        },
                        "& .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },
                    }}
                >
                    <TableContainer>
                        <Table size="small" >
                            {/* disabled={isEdit} */}
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    {/* <TableCell>
                                        <Checkbox
                                            size="small"
                                            style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < lotdetail.length}
                                            checked={selectedRows.length === lotdetail.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell> */}
                                    {/* Adjusted padding and alignment */}
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Child Roll Number</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Status</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Master Reel</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Width</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Length</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Item Code</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>GSM</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>Quantity</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>MO Number</TableCell>
                                    <TableCell style={{ padding: '4px', textAlign: 'center' }}>MA Number</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {childRolls.map((row, index) => (
                                    <TableRow key={index}>
                                        {/* <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.id)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                            />
                                        </TableCell> */}
                                        {/* Adjusted padding and border */}
                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                value={row.cr_number}
                                            />
                                        </TableCell>
                                        <TableCell style={{ padding: 2, minWidth: '100PX', border: '1px solid black', textAlign: 'center' }}>
                                            {/* <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                 value={row.status}
{}
                                                
                                            /> */}
                                            {/* {row.status === 'fg' ? (
                                                <Typography>FG</Typography>
                                            ) : row.status === 'wip' ? (
                                                <Typography>WIP</Typography>
                                            ) : row.status === 'Booked' ? (
                                                <Typography>BOOKED</Typography>
                                            ) : row.status === 'converted' ? (
                                                <Typography>CONVERTED</Typography>
                                            ) : null} */}
{row.status}
                                        </TableCell>

                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                value={row.master_reel}
                                            />
                                        </TableCell>
                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="number"
                                                value={row.d_width}
                                            />
                                        </TableCell>

                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="number"
                                                value={row.d_length}
                                            />
                                        </TableCell>

                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                value={row.item_code}
                                            />
                                        </TableCell>

                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                value={row.gsm}
                                            />
                                        </TableCell>

                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="number"
                                                value={row.achieved_qty}
                                            />
                                        </TableCell>

                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                value={row.release_no}

                                            />
                                        </TableCell>


                                        <TableCell style={{ padding: 2, border: '1px solid black' }}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '4px',
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                variant="outlined"
                                                type="text"
                                                value={row.lot_no}
                                            />
                                        </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Box>
            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button size='small' variant="contained" color="secondary" onClick={() => { onClose(); }} style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>




    )
}
export default ListOfChildRolls;